import { render, staticRenderFns } from "./coBankAction.vue?vue&type=template&id=56c18fb7&scoped=true"
import script from "./coBankAction.vue?vue&type=script&lang=js"
export * from "./coBankAction.vue?vue&type=script&lang=js"
import style0 from "./coBankAction.vue?vue&type=style&index=0&id=56c18fb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c18fb7",
  null
  
)

export default component.exports